




import { Vue, Component } from "vue-property-decorator"
import Team from "@/components/Team.vue"

@Component({
  components: { Team },
})
export default class TeamView extends Vue {}
